import React, { useState } from 'react';
import { Button, Container } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { useGetTraits, useTrait } from '../../hooks/traits-hooks';
import { useContent, useFindUniqueCTX, useTokens } from '../../hooks/token-manager';
import SimpleDropdown from './SimpleDropdown';
import DummyTraitCard from './DummyTraitCard';

const CreateToken = () => {
  const [ tokenName, setTokenName ] = useState('');

  const { createToken } = useTokens();

  return (
    <Container>
      <TextField
        onChange={ (e) => {
          setTokenName(e.target.value);
        } }
        value={ tokenName }
      />
      <Button onClick={ () => {
        return createToken({ name: tokenName });
      } }
      >
        Create new Token
      </Button>
    </Container>
  );
};

const ShowContent = (
  {
    ctxId,
    tokenId,
  },
) => {
  const [ contentText, setContentText ] = useState('');

  const {
    content,
    upsertContent,
  } = useContent(ctxId, tokenId);

  return (
    <Container>
      <TextField
        multiline
        onChange={ (e) => {
          setContentText(e.target.value);
        } }
        value={ contentText }
      />
      <Button onClick={ () => {
        return upsertContent({ text: contentText });
      } }
      >
        Save
      </Button>
      <h3>{JSON.stringify(content?.text)}</h3>
    </Container>
  );
};

const AfterPage = () => {
  const [ selectedTraitId, setSelectedTraitId ] = useState(null);
  const [ selectedTraitCategoryId, setSelectedTraitCategoryId ] = useState(null);
  const [ selectedTokenId, setSelectedTokenId ] = useState(null);

  const {
    traits,
  } = useGetTraits();

  const {
    traitCategories,
  } = useTrait(selectedTraitId);

  const { tokens } = useTokens();

  const { ctx } = useFindUniqueCTX({ trait: selectedTraitId, category: selectedTraitCategoryId });

  return (
    <Grid container>
      <Grid item xs={ 6 }>
        <SimpleDropdown
          label='Select a trait'
          value={ selectedTraitId }
          onChange={ (v) => {
            setSelectedTraitId(v);
          } }
          options={ traits }
          optionDisplay={ (trait) => { return `${ trait.name } <${ trait.id }>`; } }
        />
      </Grid>
      <Grid item xs={ 6 }>
        <SimpleDropdown
          label='Select a category'
          value={ selectedTraitCategoryId }
          onChange={ (v) => {
            setSelectedTraitCategoryId(v);
          } }
          options={ traitCategories }
          optionDisplay={ (category) => { return `${ category.name } <${ category.id }>`; } }
        />
      </Grid>
      <br />
      <br />
      <br />
      <CreateToken />
      <SimpleDropdown
        label='Select a token'
        value={ selectedTokenId }
        onChange={ (v) => {
          setSelectedTokenId(v);
        } }
        options={ tokens }
        optionDisplay={ (token) => { return `${ token.name } <${ token.id }>`; } }
      />
      <br />
      <p>
        Ctx is:
        {JSON.stringify(ctx?.id)}
      </p>
      <br />
      {(!!ctx && !!selectedTokenId) && (
        <ShowContent ctxId={ ctx.id } tokenId={ selectedTokenId } />
      )}
      <br />
      <br />
      <br />
      <Container>
        {(!!selectedTokenId) && (
          <DummyTraitCard trait={ selectedTraitId } category={ selectedTraitCategoryId } />
        )}
      </Container>
    </Grid>
  );
};

export default AfterPage;
